import React, { useState } from 'react';
import img from '../../../assets/img/test.png';
import { Images } from 'lucide-react';
import { getColumnClass } from '../../../hooks/useColomnClass';
import ButtonMore from '../../../components/Buttons/ButtonMore';
import { useScreenSize } from '../../../hooks/useScreenSize';

const ProductGallery: React.FC = () => {
  const { isMobile, isLargeDesktop } = useScreenSize();
  const [showAll, setShowAll] = useState(false);

  const product = {
    id: 1,
    imagesCount: 6,
    image: img,
  };

  const images = Array(product.imagesCount).fill(product.image);

  let maxImages = 3;

  if (isMobile) maxImages = 2;
  if (isLargeDesktop) maxImages = images.length;
  if (showAll) maxImages = images.length;

  const visibleImages = images.slice(0, maxImages);
  const columnClass = getColumnClass(visibleImages.length);

  return (
    <section className={` grid-padding`}>
      <div className="flex-row justify-end gap-3 w-100">
        <div className="flex-row align-center">
          <Images size={16} />
          <span>LG-Klimaat</span>
        </div>
      </div>

      <div className="grid gap-5 ptb-1">
        {visibleImages.map((imgSrc, index) => (
          <div key={index} className={`flex-row-align ${columnClass}`}>
            <div className="img-gallery w-100">
              <img className="img-large" src={imgSrc} alt={`Installatie ${index + 1}`} />
            </div>
          </div>
        ))}
      </div>

      {images.length > maxImages && !showAll && (
        <div className="flex-row justify-center pt-1">
          <ButtonMore text="Meer" onClick={() => setShowAll(true)} />
        </div>
      )}
    </section>
  );
};

export default ProductGallery;
